import * as r from "ramda";
import bn from 'bignumber.js';

export const oneDecimal = r.pipe(
    input => typeof input === 'string' ? input : input.toString(),
    r.replace(/[^0-9.]/g, ''),
    r.split("."),
    split => r.update(0,oneLeadingZero(split[0]), split),
    ([first, ...rest]) => r.isEmpty(rest) ? first : `${first}.${r.join('', rest)}`
);

const oneLeadingZero = r.ifElse(
    r.isEmpty,
    r.always('0'),
    input => input[0] !== '0' ? input : r.tail(input) || '0'
);

export const formatNumField = (input, decimalPlaces, roundDown) => {
    if (input === '' || input === null || input === undefined) return '';
    const formatted = oneDecimal(input);
    return r.last(formatted) === '.' || r.last(formatted) === '0' ? 
    formatted : bn(formatted).toFixed(decimalPlaces, roundDown ? 0:1).toString();
}


// WEBPACK FOOTER //
// ./src/format.js